import { assertPartialSchema, createAction, useSelector, v } from "../../../lib";
import { DigestDayDetail, ParticipantDigestDay } from "../../../model/adherence";

export enum ParticipantDataDigestActionType {
  DIGEST_DAY_SET = "DIGEST_DAY_SET",
}

export const doDIGEST_DAY_SET = createAction(ParticipantDataDigestActionType.DIGEST_DAY_SET);

interface ParticipantDataDigestState {
  [participantId: string]: DigestDateMap;
}

type DigestDateMap = { [yymmdd: number]: DigestDayDetail };

interface RootState {
  participantDataDigest: ParticipantDataDigestState;
}

/* selector */
export const useSelectParticipantDataDigest = (participantId: string) => {
  return useSelector((state: RootState) => state.participantDataDigest[participantId]);
};

export const participantDataDigestActionCreators = {
  doDIGEST_DAY_SET,
};

export const participantDataDigestDefaultState: ParticipantDataDigestState = {};

type Action = {
  type: ParticipantDataDigestActionType.DIGEST_DAY_SET;
  payload: {
    participantDigestDay: ParticipantDigestDay;
  };
};

export const participantDataDigestReducer = (
  state = { ...participantDataDigestDefaultState },
  { type, payload }: Action,
): ParticipantDataDigestState => {
  switch (type) {
    case ParticipantDataDigestActionType.DIGEST_DAY_SET:
      assertPartialSchema({
        payload,
        schema: v.object({
          // projectId: v.string().exist(),
          participantDigestDay: v.object({
            day: v.string().exist(),
            dayDate: v.string().exist(),
            dayUnixTimestamp: v.number(),
            participantId: v.string().uuid().exist(),
            garminConnectSynced: v.boolean(),
            garminConnect: v.object(),
            task: v.object(),
            dexcomDataCount: v.number(),
          }),
        }),
      });
      return updateProjectDataDigestDay(state, payload.participantDigestDay);

    default:
      return state;
  }
};

function updateProjectDataDigestDay(
  state: ParticipantDataDigestState,
  participantDigestDay: ParticipantDigestDay,
) {
  const participantId = participantDigestDay.participantId;
  const yymmdd = participantDigestDay.day.replaceAll("-", "").slice(-6);

  return {
    ...state,
    [participantId]: {
      ...(state[participantId] ?? {}),
      [yymmdd]: {
        task: participantDigestDay.task,
        garminConnect: participantDigestDay.garminConnect,
        dexcomDataCount: participantDigestDay.dexcomDataCount,
      },
    },
  };
}
